import React, { Component } from 'react';
import HomeView from '../views/HomeView';

class HomeContainer extends Component {
    render() {
        return <HomeView user={this.props.user} />;
    }
}

export default HomeContainer;



// WEBPACK FOOTER //
// ./src/components/containers/HomeContainer.jsx